import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import { Link, browserHistory } from 'react-router';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import { white } from 'material-ui/styles/colors';
import { List, ListItem } from 'material-ui/List';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Menu from 'material-ui/svg-icons/navigation/menu';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import AccountIcon from 'material-ui/svg-icons/action/account-circle';
import { translate } from 'react-i18next';

import enImg from '../assets/images/flags/en.png';
import deImg from '../assets/images/flags/de.png';
import frImg from '../assets/images/flags/fr.png';
import itImg from '../assets/images/flags/it.png';
import { headerTextColor, useDrawer } from '../theme';
import { SITE_TITLE } from '../config';
import * as authActions from '../redux/modules/auth';
import * as i18nActions from '../redux/modules/i18n';
import i18n from '../translations/i18n';
/*
  Styled components
 */
const AppBarStyled = styled(AppBar)`
  position: fixed !important;
  top: 0 !important;
  overflow: hidden !important;
`;

const MenuList = styled(List)`
  display: flex !important;
  flexdirection: row !important;
  padding: 0 !important;
`;

const ImgStyled = styled.img`
  margin: 14px !important;
  width: auto !important;
  height: 20px !important;
`;

const ListItemStyled = styled(ListItem)`
  padding: 8px !important;
  color: ${headerTextColor} !important;
`;

const SiteTitle = styled.span`
  font-weight: 300;
  line-height: 2;
  font-size: 26px;
  margin: 33px !important;
  color: ${headerTextColor} !important;
`;

const DrawerButton = styled(IconButton)`
  margin-left: 12px !important;
`;

const RightIconContainer = styled.div`
  margin-left: 20px;
`;

/*
  PropTypes / DefaultProps
 */
const propTypes = {
  menus: PropTypes.array,
  handleChangeRequestNavDrawer: PropTypes.func,
  logoutUser: PropTypes.func,
  user: PropTypes.any,
  style: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {
  menus: [],
};

class Header extends React.Component {
  logout = () => {
    this.props.logoutUser();
  };

  changeLanguage = (lang) => {
    window.localStorage.setItem('lang', lang);
    i18n.changeLanguage(lang);
  };

  render() {
    const { menus, handleChangeRequestNavDrawer, user } = this.props;

    const userBlock = (
      <Link
        onClick={() => {
          browserHistory.push(`/accounts/modify/${user.id}`);
        }}
      >
        <FlatButton
          label={user.full_name}
          style={{ color: '#ffffff', verticalAlign: 'super' }}
          icon={<AccountIcon />}
        />
      </Link>
    );
    const menuItems = menus.map((menu, index) => (
      <ListItemStyled
        innerDivStyle={{
          padding: '16px 16px 16px 50px',
          fontSize: 15,
        }}
        key={index}
        primaryText={menu.text}
        leftIcon={menu.icon}
        containerElement={<Link to={menu.link} />}
      />
    ));

    let iconLeft = null;
    let title = null;

    if (useDrawer) {
      iconLeft = (
        <DrawerButton onClick={handleChangeRequestNavDrawer}>
          <Menu color={white} />
        </DrawerButton>
      );

      title = null;
    } else {
      iconLeft = <SiteTitle>{SITE_TITLE}</SiteTitle>;
      title = <MenuList>{menuItems}</MenuList>;
    }

    return (
      <AppBarStyled
        iconElementLeft={iconLeft}
        title={title}
        style={this.props.style}
        iconElementRight={
          <RightIconContainer>
            {userBlock}
            <IconMenu
              color={white}
              iconButtonElement={
                <IconButton>
                  <MoreVertIcon color={white} />
                </IconButton>
              }
              targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
              <MenuItem
                primaryText="English"
                rightIcon={<ImgStyled src={enImg} />}
                onTouchTap={() => {
                  this.changeLanguage('en');
                }}
              />
              <MenuItem
                primaryText="Deutsch"
                rightIcon={<ImgStyled src={deImg} />}
                onTouchTap={() => {
                  this.changeLanguage('de');
                }}
              />
              <MenuItem
                primaryText="Francese"
                rightIcon={<ImgStyled src={frImg} />}
                onTouchTap={() => {
                  this.changeLanguage('fr');
                }}
              />
              <MenuItem
                primaryText="Italiano"
                rightIcon={<ImgStyled src={itImg} />}
                onTouchTap={() => {
                  this.changeLanguage('it');
                }}
              />
              <Divider />
              <MenuItem
                primaryText={this.props.t('sign_out')}
                onTouchTap={this.logout}
                containerElement={<Link to="/login" />}
              />
            </IconMenu>
          </RightIconContainer>
        }
      />
    );
  }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

function mapStateToProps() {
  return {};
}

const actions = Object.assign({}, authActions, i18nActions);
const extended = translate(['translations'], { i18n })(Header);
export default connect(mapStateToProps, actions)(localize(extended, 'locale'));



// WEBPACK FOOTER //
// ./src/components/Header.js